
    import Vue from 'vue';
    import { RouterLink } from 'vue-router';
    import FilePathService from '@/apps/shared/services/filePath-service';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import ivaConditionService from '@/apps/shared/services/ivaConditions-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';


    export default Vue.extend({
        components: {
            RouterLink,
            WhatsApp,
            XBreadcrumb
        },
        name: 'APinsured-view',
        data() {
            return {
                icono: null,
                ownerIsInsured: true,
                capital: null,
                coversDetail: [],
                maxSelections: 2,
                primerCuota: 0,
                DataPlan: { planDescription: '' },
                documentTypeList: [{ id: "", text: "" }],
                ivaConditionList: [{ id: "", text: "" }],
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                isNotSelectedDocumentType: true,
                currentStep: 3,
                totalStep: 3,
                // Arrays para cada tipo de persona
                subrogacionPeople: [],
                repeticionPeople: [],
                // Variable para determinar el tipo a agregar ('subrogacion' o 'repeticion')
                tipoPersonaSeleccionada: "",
                personToAdd: {},
                searchButtonDisable: true,
                personToAddDocTypeSelected: null,
                personToAddNumDoc: null,
                titularPerson: null,
                policyOwner: null,
                numDocChange: null,
                numDocExisting: null,
                personToDelete: {},
                isPerson: false,
                isJuridico: false,
                multiplePeopleWithSameIdentifier: [],
                personWithSameIdentifierSelected: null,
                premiumWithoutDiscount: null,
                thereIsDiscount: false,
                vigencyStart: "",
                modalText: '',
                email: null,
                product: null,
                urlAnterior: null,
                hasDiscount: null,
                referente: null,
                medium: null,
                pas: null,
            };
        },
        created() {
            this.personToDelete = this.getDefaultPerson();
            this.personToAdd = this.getDefaultPersonToAdd();

            window.globalThis.validateNumDoc = (val) => {
                let valid = true;
                let message = "";

                if (!this.personToAddDocTypeSelected) {
                    return { valid: false, message: "Debe seleccionar un tipo de documento." };
                }

                // Asegurarnos de que val es un string y eliminar espacios innecesarios
                val = String(val || "").trim();  // Aseguramos que 'val' sea un string y lo limpiamos de espacios
                let numericVal = val.replace(/\D/g, "");

                if (this.personToAddDocTypeSelected.id === 'D') {
                    if (numericVal.length !== 7 && numericVal.length !== 8) {
                        this.searchButtonDisable = true;
                        message = numericVal.length > 0 ? "La cantidad de dígitos es incorrecta." : "Este campo es obligatorio.";
                        valid = false;
                    } else {
                        if (this.numDocExisting !== numericVal) {
                            this.numDocChange = true;
                            this.numDocExisting = numericVal;
                        }
                        this.searchButtonDisable = false;
                        message = "";
                        valid = true;
                    }
                } else if (this.personToAddDocTypeSelected.id === 'J') {
                    // Validar CUIT
                    if (numericVal.length !== 11 || !this.validarCuit(numericVal)) {
                        message = "CUIT inválido. Debe tener 11 digitos y comenzar con 30, 33 o 34";
                        valid = false;
                        this.searchButtonDisable = true;
                    } else {
                        this.searchButtonDisable = false;
                        message = "";
                        valid = true;
                    }
                }

                else {
                    this.searchButtonDisable = false;
                }

                if (!val) {
                    this.searchButtonDisable = true;
                }

                return { valid, message };
            };
        },
        methods: {
            validarCuit(cuit) {
                // valida que tenga 11 dígitos numericos
                if (!/^\d{11}$/.test(cuit)) return false;

                // valida prefijo permitido: 30, 33, 34
                const prefix = cuit.substring(0, 2);
                if (!["30", "33", "34"].includes(prefix)) return false;

                // calculo de ultimo numero
                const mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
                let total = 0;

                for (let i = 0; i < 10; i++) {
                    total += parseInt(cuit[i]) * mult[i];
                }

                let resto = total % 11;
                let digito = resto === 0 ? 0 : resto === 1 ? 9 : 11 - resto;

                // Comparar con el ultimo numero ingresado
                return digito === parseInt(cuit[10]);
            },
            getDefaultPerson() {
                return {
                    id: 0,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docType: { name: "" },
                    rol: { name: "" },
                    birthday: null
                };
            },
            getDefaultPersonToAdd() {
                return {
                    isPersonExist: false,
                    activeForm: false,
                    birthday: null,
                    firstName: "",
                    lastName: "",
                    docNum: "",
                    docTypeSelected: null,
                    email: "",
                    selectedIvaCondition: null,
                    areaCode: "",
                    telephone: null,
                    hasLocality: false,
                    MaximDigitSuperatedDni: false,
                    age: "",
                    selectedLocality: null,
                    address: null,
                    maximDigitSuperatedDni: false,
                    activeFormPersonNotExist: false,
                    alreadyExists: false
                };
            },
            disableAcceptNewPersonButton() {
                return (
                    !this.personToAddNumDoc ||
                    !this.personToAddDocTypeSelected ||
                    !this.personToAdd.birthday ||
                    !this.personToAdd.firstName ||
                    !this.personToAdd.lastName
                );
            },
            openCancelModal() {
                this.$refs.cancelModal.open();
            },
            closeCancelModal() {
                this.$refs.cancelModal.close();
            },
            closeDeleteAssuredModal() {
                this.$refs.deleteAssuredModal.close();
                this.resetPersonToDelete();
            },
            resetPersonToDelete() {
                this.personToDelete = this.getDefaultPerson();
            },
            openDeleteAssuredModal(item: any) {
                this.personToDelete = { ...item };
                this.$refs.deleteAssuredModal.open();
            },
            openSelectMultiplePeopleModal(peopleList: any[]) {
                this.isPeopleWithSameIdentifierModalOpen = true;
                this.resetMultiplePeopleModalValues();
                let idCounter = 1;
                this.multiplePeopleWithSameIdentifier = peopleList.map(person => ({
                    id: idCounter++,
                    birthday: person.birthday,
                    firstName: person.firstName,
                    lastName: person.lastName,
                    email: person.email,
                    selectedIvaCondition: person.ivaConditionFiscalId,
                    areaCode: person.phoneAreaCode,
                    telephone: person.phoneNumber,
                    hasLocality: person.hasLocality,
                    address: person.address ? { ...person.address } : null,
                    document: person.document || null,
                }));
                this.$refs.selectMultiplePeopleModal.open();
            },
            resetPersonToAddModal() {
                this.personToAddDocTypeSelected = this.documentTypeList.find((p: any) => p.text === "DNI");
                this.personToAddNumDoc = "";
                this.resetPersonToAdd();
                this.personToAdd = this.getDefaultPersonToAdd();
            },
            resetMultiplePeopleModalValues() {
                this.multiplePeopleWithSameIdentifier = [];
                this.personWithSameIdentifierSelected = null;
            },
            closeSelectMultiplePeopleModal(flag = true) {
                this.isPeopleWithSameIdentifierModalOpen = false;
                this.resetMultiplePeopleModalValues();
                if (flag) {
                    this.resetPersonToAddModal();
                }
                this.$refs.selectMultiplePeopleModal.close();
            },
            onSelectedClient(id: number) {
                this.personWithSameIdentifierSelected = id;
                const selectedPerson = this.multiplePeopleWithSameIdentifier.find(
                    item => item.id === this.personWithSameIdentifierSelected
                );
                const exists = [...this.subrogacionPeople, ...this.repeticionPeople].some(member =>
                    member.docType.id === this.personToAddDocTypeSelected.id &&
                    member.docNum === this.personToAddNumDoc
                );
                this.personToAdd.alreadyExists = exists;
                this.setPersonToAdd(selectedPerson);
                if (this.personToAddNumDoc && !this.personToAdd.alreadyExists) {
                    this.finallySetPersonToAddOrEdit();
                    this.closeSelectMultiplePeopleModal();
                } else {
                    this.closeSelectMultiplePeopleModal(false);
                }
            },
            deleteAssured(id: number) {
                let index = this.subrogacionPeople.findIndex(member => member.id === id);
                if (index !== -1) {
                    this.subrogacionPeople.splice(index, 1);
                } else {
                    index = this.repeticionPeople.findIndex(member => member.id === id);
                    if (index !== -1) {
                        this.repeticionPeople.splice(index, 1);
                    }
                }
                this.closeDeleteAssuredModal();
            },
            closePersonToAddModal() {
                this.$refs.personToAddModal.close();
                if (!this.isPeopleWithSameIdentifierModalOpen) {
                    this.resetPersonToAddModal();
                }
            },
            resetPersonToAdd() {
                this.personToAdd = this.getDefaultPersonToAdd();
            },
            openPersonToAddModal() {
                this.personToAddDocTypeSelected = this.documentTypeList.find((p: any) => p.text === "DNI");
                this.personToAddNumDoc = "";
                this.resetPersonToAdd();
                this.$refs.personToAddModal.open();
            },
            addInsured(type: string) {
                this.tipoPersonaSeleccionada = type;
                this.openPersonToAddModal();
            },
            anterior() {
                sessionStorage.setItem("pressBack", "true");
                var product = sessionStorage.getItem('productId');
                var route;
                switch (product) {
                    case "711":
                        route = 'integro-max-tab-personToCover'
                        break;

                    case "555":
                        route = 'ocassion-of-work-tab-personToCover'
                        break;
                    case "387":
                        route = 'ap-24-hs-tab-personToCover'
                        break;
                    default:
                        break;
                }
                this.$router.push({ name: route });
            },
            siguiente() {
                sessionStorage.setItem("pressBack", "false");
                sessionStorage.setItem("subrogacionPeople", JSON.stringify(this.subrogacionPeople));
                sessionStorage.setItem("repeticionPeople", JSON.stringify(this.repeticionPeople));

                var product = sessionStorage.getItem('productId');
                var route;
                switch (product) {
                    case "555":
                        route = 'ocassion-of-work-APSummary'
                        break;
                    case "711":
                        route = 'integro-max-APSummary'
                        break;
                    case "387":
                        route = 'ap-24-hs-APSummary'
                        break;
                    default:
                        break;
                }
                this.$router.push({
                    name: route,
                })
            },
            formatDate(dateString: string) {
                if (!dateString) {
                    return "";
                }
                dateString = dateString.replace(/^"|"$/g, '');
                const [year, month, day] = dateString.split('T')[0].split('-');
                return `${day}/${month}/${year}`;
            },
            getFilePath() {
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        var product = sessionStorage.getItem('productId');
                        var url;
                        switch (product) {
                            case "711":
                                url = 'integro-max'
                                break;
                            case "555":
                                url = 'ocasion-de-trabajo'
                                break;
                            case "387":
                                url = 'ap-24-hs'
                                break;
                            default:
                                break;
                        }
                        window.location.href = response + url;
                    });
            },
            getDocumentType() {
                return documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length) {
                        this.documentTypeList = response.map((element: any) => ({
                            ...element,
                            id: element["id"],
                            text: element["name"].trim()
                        }));
                        this.documentTypeList.push({ id: 'J', text: 'CUIT', name: "CUIT" });
                        this.personToAddDocTypeSelected = this.documentTypeList.find((p: any) => p.name === "DNI");
                    }
                    else {
                        const eventData = {
                            'pas': this.pas,
                            'email': this.email,
                            'product': this.product,
                            'event': 'errorServidor',
                            'paso': 'cotizador-' + this.product + '-clausulas',
                            'referente': this.referente,
                            'medio': this.medium
                        };

                        window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                        window.globalThis.dataLayer.push(eventData);

                        const customWindow = window as typeof window & {
                            _qsie?: Array<typeof eventData>;
                        };

                        customWindow._qsie ??= [];
                        customWindow._qsie.push(eventData);
                    }
                });
            },
            getIvaConditions() {
                ivaConditionService.getIvaConditionsList().then(response => {
                    if (response.length) {
                        this.ivaConditionList = response.map((element: any) => ({
                            ...element,
                            id: element["id"].toString(),
                            text: element["name"]
                        }));
                    }
                });
            },
            addNewPerson() {
                this.personToAdd.docNum = this.personToAddNumDoc;
                this.personToAdd.docType = this.personToAddDocTypeSelected;
                this.addOrEditPerson();
            },
            setPersonToAdd(personData: any) {
                this.personToAdd.activeFormPersonNotExist = false;
                this.personToAdd.isPersonExist = true;
                this.personToAdd.activeForm = true;
                this.personToAdd.docNum = this.personToAddNumDoc;
                this.personToAdd.birthday = personData.birthday;
                this.personToAdd.firstName = personData.firstName;
                this.personToAdd.lastName = personData.lastName;
                this.personToAdd.email = personData.email || "";

                if (this.personToAddDocTypeSelected.id != "J") {
                    this.personToAdd.docType = this.documentTypeList.find((p: any) => p.id.trim() === personData.document.identificationTypeCode);
                    this.personToAdd.selectedIvaCondition = personData.ivaConditionFiscalId
                        ? this.ivaConditionList.find((o: any) => o.id == personData.ivaConditionFiscalId || o.name == personData.ivaConditionFiscalId)
                        : this.ivaConditionList.find((o: any) => o.id == 4 || o.name === "Consumidor Final");
                }
                else {
                    this.personToAdd.docType = this.personToAddDocTypeSelected;
                    this.personToAdd.selectedIvaCondition = personData.selectedIvaCondition ? personData.selectedIvaCondition :  personData.ivaConditionFiscalId;
                }

                this.personToAdd.areaCode = personData.phoneAreaCode
                    ? personData.phoneAreaCode.replace(/^0+/, '')
                    : "";
                this.personToAdd.telephone = personData.phoneNumber
                    ? personData.phoneNumber.replace(/^15+/, '')
                    : null;
                this.personToAdd.hasLocality = personData.hasLocality;
                if (personData.address) {
                    this.personToAdd.address = { ...personData.address };
                }
                if (personData.document) {
                    this.personToAdd.document = personData.document;
                }
            },
            // Eliminada toda validación sobre comparación con personas ya cargadas fuera de esta pantalla.
            searchPersonToAdd() {
                NF.UI.Page.blockCustom({ message: 'Cargando datos...' });
                this.personToAdd = { ...this.getDefaultPersonToAdd() };
                // Solo se revisa que la persona no exista ya en los arrays locales.
                const existing = [...this.subrogacionPeople, ...this.repeticionPeople];
                this.personToAdd.alreadyExists = existing.some(member =>
                    member.docType.id === this.personToAddDocTypeSelected.id &&
                    member.docNum === this.personToAddNumDoc
                );
                if (this.personToAddNumDoc && !this.personToAdd.alreadyExists) {
                    const dni = this.personToAddNumDoc;
                    const docTypeSeleccionado = this.personToAddDocTypeSelected.name.trim();
                    searchPersonService.GetSearchPersonData(dni, this.personToAddDocTypeSelected.id, false)
                        .then(response => {
                            if (response.searchPersonResult.length > 1) {
                                this.openSelectMultiplePeopleModal(response.searchPersonResult);
                                return;
                            }
                            const result = response.searchPersonResult[0];
                            if (result && (result.firstName || result.razonSocial || result.lastName)) {
                                this.setPersonToAdd(result);
                            } else {
                                this.personToAdd.isPersonExist = false;
                                this.personToAdd.activeFormPersonNotExist = true;
                                this.personToAdd.firstName = "";
                                this.personToAdd.email = "";
                                this.personToAdd.areaCode = "";
                                this.personToAdd.telephone = null;
                                this.personToAdd.age = "";
                                this.personToAdd.birthday = null;
                                this.personToAdd.selectedIvaCondition = this.ivaConditionList.find((o: any) => o.id == 4 || o.name === "Consumidor Final");
                                this.personToAdd.lastName = "";
                                this.personToAdd.selectedLocality = null;
                            }
                            if (dni.toString().length > 0 && dni.toString().length < 9) {
                                this.personToAdd.MaximDigitSuperatedDni = false;
                            } else {
                                if (docTypeSeleccionado === "DNI") {
                                    this.personToAdd.MaximDigitSuperatedDni = true;
                                    this.personToAdd.firstName = "";
                                    this.personToAdd.lastName = "";
                                    this.personToAdd.birthday = null;
                                    this.personToAdd.isPersonExist = false;
                                    this.personToAdd.isNotSelectedDocumentType = false;
                                    this.personToAdd.age = "";
                                    this.personToAdd.activeFormPersonNotExist = true;
                                } else {
                                    this.personToAdd.MaximDigitSuperatedDni = true;
                                }
                            }
                        })
                        .finally(() => {
                            NF.UI.Page.unblock();
                            if (!this.isPeopleWithSameIdentifierModalOpen && this.personToAdd.isPersonExist) {
                                this.finallySetPersonToAddOrEdit();
                            }
                        });
                } else {
                    this.personToAddNumDoc = null;
                    NF.UI.Page.unblock();
                }
            },
            finallySetPersonToAddOrEdit() {
                if (this.personToAdd && this.personToAdd.isPersonExist) {
                    this.addOrEditPerson();
                }
            },
            addOrEditPerson() {
                const id = this.subrogacionPeople.length + this.repeticionPeople.length + 1;
                const newPerson = {
                    id: id,
                    isPersonExist: this.personToAdd.isPersonExist,
                    birthday: this.personToAdd.birthday,
                    firstName: this.personToAdd.firstName,
                    lastName: this.personToAdd.lastName,
                    docNum: this.personToAdd.docNum,
                    docType: this.personToAdd.docType,
                    email: this.personToAdd.email,
                    selectedIvaCondition: this.personToAdd.selectedIvaCondition.id,
                    areaCode: this.personToAdd.areaCode,
                    telephone: this.personToAdd.telephone,
                    hasLocality: this.personToAdd.hasLocality,
                    age: this.personToAdd.age,
                    selectedLocality: this.personToAdd.selectedLocality,
                    address: this.personToAdd.address,
                    tipoPersona: this.tipoPersonaSeleccionada
                };
                if (this.tipoPersonaSeleccionada === 'subrogacion') {
                    this.subrogacionPeople.push(newPerson);
                } else if (this.tipoPersonaSeleccionada === 'repeticion') {
                    this.repeticionPeople.push(newPerson);
                }
                this.personToAddNumDoc = null;
                this.closePersonToAddModal();
            },            
            async pageCustomization() {
                var product = sessionStorage.getItem('productId');
                let defaultTitle = '';
                let actualPath = '';
                let icon = '';
                switch (product) {
                    case '711': defaultTitle = 'Integro Max'; this.productName = "apintegro"; actualPath = '/integro-max'; icon = "/Logos/AP_Integro.svg"; this.urlAnterior = "integro-max-tab-personToCover"; this.product = "apintegro"; break;
                    case '555': defaultTitle = 'Ocasión de Trabajo'; this.productName = "aptrabajo"; actualPath = '/ocasion-de-trabajo'; icon = "/Logos/AP_OT.svg"; this.urlAnterior = "ocassion-of-work-tab-personToCover"; this.product = "aptrabajo"; break;
                    case '387': defaultTitle = 'AP - 24HS'; this.productName = "ap24"; actualPath = '/ap-24-hs'; icon = "/Logos/AP_24.svg"; this.urlAnterior = "ap-24-hs-tab-personToCover"; this.product = "ap24"; break;
                }
                const actualStep = 'optionals';
                this.icono = icon
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, null);
                    const title = this.$store.getters.getWebSaleData?.pageCustomization?.navbar?.title ?? '';
                    this.pas = title === defaultTitle ? null : title;
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },
            openInfoModal(texto: string) {
                this.modalText = texto;
                this.$refs.infoModal.open();
            },
            closeInfoModal() {
            this.$refs.infoModal.close();
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'Default' + this.product + 'GTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
        },

        async mounted() {
            NF.UI.Page.block();
            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            this.vigencyStart = this.formatDate(sessionStorage.getItem("vigencyStart") || "");

            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;
            var medium = sessionStorage.getItem("Medium");
            medium == 'null' || medium == null ? this.medium = 'organic' : this.medium = medium;

            await this.pageCustomization();
            this.getDocumentType();
            this.getIvaConditions();            
            this.updateByProductGoogleAnalytics();
            const planDataSelected = JSON.parse(sessionStorage.getItem("PlanSelected") || "null");
            if (planDataSelected) {
                this.DataPlan = planDataSelected;
                this.primerCuota = this.DataPlan.premioMensual;
                this.hasDiscount = this.DataPlan.hasDiscount;
                this.premiumWithoutDiscount = this.DataPlan.hasDiscount ? this.DataPlan.premiumWithoutDiscount : null;
                this.capital = this.DataPlan.capital;
                this.coversDetail = planDataSelected.calculosFinales;
            }

            const subrogacionPeople = JSON.parse(sessionStorage.getItem("subrogacionPeople") || "null");
            if (subrogacionPeople) {
                this.subrogacionPeople = subrogacionPeople;
            }
            const repeticionPeople = JSON.parse(sessionStorage.getItem("repeticionPeople") || "null");
            if (repeticionPeople) {
                this.repeticionPeople = repeticionPeople;
            }

            this.email = JSON.parse(sessionStorage.getItem("contratante")).email;

            const eventData = {
                'pas': this.pas,
                'email': this.email,
                'product': this.product,
                'event': 'cotizador-' + this.product + '-clausulas',
                'referente': this.referente,
                'medio': this.medium
            };

            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            window.globalThis.dataLayer.push(eventData);

            const customWindow = window as typeof window & {
                _qsie?: Array<typeof eventData>;
            };

            customWindow._qsie ??= [];
            customWindow._qsie.push(eventData);

            NF.UI.Page.unblock();
        }
    });
